<!--修改密码弹窗-->
<template>
	<dialogBody ref="dialogBody" @confirm="confirm" @cancel="cancel">
		<template slot="title">修改密码</template>
		<div>
			<p class="jbxx">基本信息</p>
		</div>
		<div class="mscs">
			<p class="ms oldPwd">请输入旧密码</p>
			<input class="msc" type="password" v-model="oldPsw">
		</div>
		<div class="mscs">
			<p class="ms newPwd">请输入新密码</p>
			<input class="msc" type="password" v-model="newPsw">
		</div>
		<div class="mscs">
			<p class="ms reNewPwd">再次输入新密码</p>
			<input class="msc" type="password" v-model="reNewPsw">
		</div>
		<p v-if="errors.length">
			<!--<b>验证出现下列问题:</b>-->
			<span class="error" v-show="errors.length>0">{{ errors }}</span>
		</p>
	</dialogBody>
</template>

<script>
	import dialogBody from './dialogBody.vue'
	export default {
		components: {
			dialogBody
		},
		props: [],
		data() {
			return {
				oldPsw: '',
				newPsw: '',
				reNewPsw: '',
				errors: '',
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			show() {
				this.$refs.dialogBody.open()
			},
			confirm() {
				this.errors = ''
				if(!this.oldPsw) {
					this.errors = "请输入旧密码"
				} else if(!this.newPsw) {
					this.errors = "请输入新密码"
				} else if(!this.reNewPsw) {
					this.errors = "请再次输入新密码"
				} else if(this.reNewPsw != this.newPsw) {
					this.errors = "两次新密码输入不同!"
				} else {
					//修改密码
					this.$api.userApi.updatePSW(hex_md5(this.oldPsw), hex_md5(this.newPsw), respon => {
						this.$dialogMethod.showMessage('修改成功!')
						this.$refs.dialogBody.close()
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				}
			},
			cancel() {
				this.$refs.dialogBody.close()
			}
		}
	}
</script>

<style scoped>
	.error {
		color: red;
	}
	
	.jbxx {
		font-size: 0.2rem;
		font-weight: 1000;
		border-bottom: 1px solid #D6D6D6;
		padding-bottom: 0.1rem;
		;
	}
	
	.ms {
		float: left;
	}
	
	.mscs {
		margin: 0.15rem;
		text-align: right;
	}
	
	input {
		border: 1px solid #ccc;
		padding: 2px 0px;
		border-radius: 3px;
		padding-left: 5px;
		-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
		box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
		-webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
		-o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
		transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s
	}
	
	input:focus {
		border-color: #66afe9;
		outline: 0;
		-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
		box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6)
	}
</style>